import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { Store } from '@ngrx/store';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { CreateAssociatedFormComponent } from '../discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/create-associated-form.component';
import { ManageSelectedSuggestionData, UserTemplateSuggestionInputInterface } from './suggestion';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'common-suggestion-view',
  templateUrl: './common-suggestion-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonSuggestionViewComponent implements OnInit, OnDestroy {
  @Input() origin = '';
  @Input() vaultUserFormId;
  @Input() title: string = '';
  @Input() source = 'onboarding';
  @Input() inlineComponent = false;
  @Input() isFromFamilyTree = false;
  @Input() type;

  @Input() suggestionData: UserTemplateSuggestionInputInterface[] = [];
  @Input() selectedData: ManageSelectedSuggestionData[] = [];
  @Output() selectItemEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() addMXEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  stateObject;
  screenWidth: number;
  subscription = new Subscription();
  resizeObservable$: Observable<Event>;
  templateSaerchFormControl = new UntypedFormControl();

  constructor(private store: Store, private dialog: MatDialog, private vaultService: VaultStoreEffects, private cd: ChangeDetectorRef) {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((item) => {
        this.stateObject = item;
      })
    );
  }

  addMxData() {
    this.addMXEventEmitter.emit({});
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
  }

  getFormData(id) {
    if (this.stateObject && this.stateObject.forms) {
      return this.stateObject.forms.filter((form) => form.id == id);
    }
  }

  selectSuggestionItem(item, type) {
    this.selectItemEventEmitter.emit({ event: item, type: type });
  }

  addNewForm(formData) {
    this.createFormPopup({ selectedId: formData.id, fromSuggestion: true, vault_user_form_id: this.vaultUserFormId });
  }

  createFormPopup(data) {
    let newData = {
      ...data,
      source: this.source,
      origin: this.origin,
    };
    const sharedDialogRef = this.dialog.open(CreateAssociatedFormComponent, {
      width: '680px',
      maxWidth: '90%',
      data: newData,
      // panelClass: 'create-share-link-dialog',
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((res) => {
        if (res.id) {
          this.selectItemEventEmitter.emit({ event: { ...res }, type: res.type });
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}

// Input object structure
// title:""
// vaultUserFormId:vaultUserFormId
// suggestionData: UserTemplateSuggestionInputInterface[] = [
//   {
//     type: SuggestionType.USER,
//     userData: [
//       {
//         user_id: '83efcb40-a4d0-11ee-9c46-16fdc50bb6a1',
//         name: 'Hena',
//         relationship_name: 'Aunt',
//         user_profile_image_url: '',
//         // connection_status: 'invited',
//       }
//     ],
//   },
//   {
//     type: SuggestionType.ENTITY,
//     vaultFormTypeData: [
//       {
//         id: 149,
//         type: 'Mortgage',
//         image: 'https://s3.amazonaws.com/testing.kinnect.articles/form-images/149.svg',
//         entityData: [
//           {
//           id: '00a1f170-f864-4598-92fe-2fbf605f0692',
//           name: "dilip n5's Irrevocable Trust 23",
//           type: 'Irrevocable Trust',
//           profile_image_url: 'https://s3.amazonaws.com/testing.kinnect.articles/form-images/1242.svg',
//           vault_form_id: 1242,
//           // vfid: 'b4dde0c2-a3bf-11ee-823e-16fdc50bb6a1',
//         }
//     ],
//       }
//     ],
//   },
// ];
